/*
 *  			'License for ONE AXA SOFTWARE - Inner Source'
 * 					L O A S - I S
 * 
 * The following License aims to be applied between the AXA Companies, according to the following definition:
 * "AXA Companies" means AXA, Société Anonyme with a “AXA Companies ” Board of Directors having its principal offices at 25, avenue Matignon, 75008 Paris, registered on the Commercial Registry of Paris under the number 572 093 920; and (i) any other company controlled by, or controlling AXA, with a company being considered as controlling another: (a) when it holds directly or indirectly a portion of the capital according to it the majority of the voting rights in general meetings of shareholders of this company; (b) when it holds solely the majority of the voting rights in this company by virtue of an agreement concluded with other partners or shareholders and which is not contrary to the interest of the company; (c) when it determines de facto, by voting rights which it holds, the decisions in the general meetings of shareholders of this company; (d) in any event, when it holds, directly or indirectly, a portion of voting rights greater than 40% and when no other partner or shareholder holds directly or indirectly a portion which is greater than its own; (ii) any economic interest group in which AXA and/or one or more other Companies of the AXA Group participates for at least 50% in operating costs; (iii) in the cases where the law applicable to a company limits voting rights or control (such as defined here in above), this company will be deemed to be a company of the AXA Group, if the voting rights in 2 Binding Corporate Rules – AXA Group – version 2013 general shareholders’ meetings or the control held by a Company of the AXA Group reaches the maximum amount fixed by said applicable law; and (iv) all AXA Companies constitute the “AXA Group” (hereafter "One AXA").  (Binding Corporate Rules - AXA Group - version 2019).
 * 
 * Software credits: 
 * 	Creator: AXA GO GETD
 * 	Main contributors: AXA GO GETD
 * 
 * Permission is hereby granted, free of charge, to any person or entity within One AXA obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software within One AXA, including the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 * 
 * The above credit notice and this permission notice shall be included in all copies or substantial portions of the Software.
 * Any improvement or modification of the Software shall be made available to the whole One AXA, under the terms of this License.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

// this input text to a div behind the flow text area, and encapsulates the text in marks
// with the desired styles, to simulate like highlight the text

const applyHighlights = (text, errorStr) => {
  let encapsuleText = text
    .replace(/\n$/g, '\n\n') // clean empty lines
    .replace(/ +$/, '')
    // valid commands
    .replace(/(^ *import .+$)/gm, '<mark id="importMark">$1</mark>')
    .replace(/(^ *translations.*$)/gm, '<mark id="translationsTitleMark">$1</mark>')
    .replace(/(^ *- [a-z][a-z].*$)/gm, '<mark id="translationsBodyMark">$1</mark>')
    .replace(/(restart)/gm, '<mark id="restartMark">$1</mark>')
    .replace(/(nlp)/gm, '<mark id="nlpMark">$1</mark>')

    // main commands
    .replace(/(^ *dialog .+$)/gm, '<mark id="dialogMark">$1</mark>')
    .replace(/(^ *run .+$)/gm, '<mark id="runMark">$1</mark>')
    .replace(/(^ *card .+$)/gm, '<mark id="cardMark">$1</mark>')
    .replace(/(^ *call .+$)/gm, '<mark id="callMark">$1</mark>')
    .replace(/(^ *say .+$)/gm, '<mark id="sayMark">$1</mark>')
    .replace(/(^ *ask .+$)/gm, '<mark id="askMark">$1</mark>')
    .replace(/(^ *set .+$)/gm, '<mark id="setMark">$1</mark>')
    .replace(/(^ *inc .+$)/gm, '<mark id="incMark">$1</mark>')
    .replace(/(^ *dec .+$)/gm, '<mark id="decMark">$1</mark>')
    // check askValidation in backend
    .replace(
      /^(( *ask) ([a-z][a-zA-Z0-9]*(((\-|\_)[a-zA-Z0-9]+)+)?)|( *ask)(([A-Z])[a-zA-Z0-9]+ ([a-z][a-zA-Z0-9]*(((\-|\_)[a-zA-Z0-9]+)+)?))(?<cfg_json_group> \{.*\:(\{.*\:.*\}|.*)\})?)$/gm,
      '<mark id="askMark">$1</mark>'
    )

    // comments Props
    .replace(/^( *# ?title ?:.*$)/gm, '<mark id="dialogTitleMark">$1</mark>')
    .replace(/^( *# ?description ?:.*$)/gm, '<mark id="dialogDescriptionMark">$1</mark>')
    .replace(/^( *# ?category ?:.*$)/gm, '<mark id="dialogCategoryMark">$1</mark>')
    .replace(/^( *# ?type ?:.*$)/gm, '<mark id="dialogTypeMark">$1</mark>')
    .replace(/^( *#.*$)/gm, '<mark id="setComment">$1</mark>');
  if (!errorStr) encapsuleText = encapsuleText.replace(/(^ *[a-zA-Z].*)/gm, '<mark id="errorMark">$1</mark>');

  if (errorStr) {
    const regex = new RegExp(`(${errorStr})`, 'gm');
    encapsuleText = encapsuleText.replace(regex, `<mark id="errorMark">$1</mark>`);
  }

  return encapsuleText;
};
const highlightCode = (stringToFind, { highlightsRef, textAreaRef }) => {
  if (!highlightsRef.current) return false;
  if (!textAreaRef.current) return false;

  const $highlights = highlightsRef.current;
  const $textarea = textAreaRef.current.resizableTextArea.textArea;
  const text = $textarea.value;
  $highlights.innerHTML = applyHighlights(text, stringToFind);
};
export default highlightCode;
